import { RootState } from "../types";

export const getTargetedReconciliation = (state: RootState) => state.targetedReconciliation.targetedReconciliation;
